/* src/app/layout/header/header.component.scss */
.di-app-header {
  padding: 10px 0;
  background: #fff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
}
.di-app-header .di-logo-nav-wrapper {
  display: flex;
  align-items: center;
}
.di-app-header .di-logo-nav-wrapper a.di-logo {
  display: inline-block;
  width: 110px;
  min-width: 110px;
  margin-right: 24px;
}
.di-app-header .di-logo-nav-wrapper a.di-logo img {
  cursor: pointer;
}
.di-app-header .di-product-user-dropdown {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
mobile-menu {
  display: block;
}
mobile-menu.menu-opened .di-mobile-menu-wrapper {
  left: 0;
}
mobile-menu.menu-opened .mobile-menu-data {
  left: 0;
}
mobile-menu.menu-opened .mobile-menu-bg {
  opacity: 1;
}
@media screen and (max-width: 992px) {
  .di-app-header .toggleMobileMenu {
    padding: 0;
    border: 0;
    background: transparent;
    width: 32px;
    height: 32px;
  }
  .di-app-header .toggleMobileMenu .material-symbols-outlined {
    font-size: 32px;
    width: 32px;
    height: 32px;
  }
  .di-app-header .di-logo-nav-wrapper {
    height: 36px;
    justify-content: center;
  }
  .di-app-header .di-logo-nav-wrapper a.di-logo {
    margin-right: 12px;
  }
}
/*# sourceMappingURL=header.component-PPNN6QV4.css.map */
